"use client";

import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { Link } from "react-router-dom";
// import MobileApplications from "./MobileApplications";

const RealSolutions = () => {
  const solutions = [
    {
      title: "Advanced School Management System",
      description: "Simplifies school tasks, allowing teachers to efficiently manage attendance and grades. By streamlining their work, teachers can focus more on helping students succeed",
      image: "/images/projects/schoolmanagementsystem.png",
      link: "https://dev.vetviewacademy.co.ke/login",
    },
    {
      title: "Loan Management System",
      description: "Platform for SACCOs and microfinance institutions to manage members, issue and track loans, monitor savings, calculate interests, and generate financial reports all in one system.",
      image: "/images/projects/loansystem.png",
      link: "https://tumsifu.ynetsolution.com/",
    },
    {
      title: "YNET Study Hub",
      description: "A comprehensive platform offering premium educational resources for educators, students, and professionals at every stage of their learning journey.",
      image: "/images/projects/ynetstudyhub.png",
      link: "https://ynetstudyhub.com/",
    },
    {
      title: "Rental Hub",
      description: "RentalHub provides a comprehensive solution for landlords to manage properties, tenants, and maintenance requests all in one place.",
      image: "/images/projects/rentalhub.png",
      link: "https://www.rentalhub.co.ke/",
    },
    {
      title: "IY Events",
      description: "Easy online booking system for quick and hassle-free access to your favorite events.Receive your tickets right in your inbox, eliminating the need for physical passes.",
      image: "/images/projects/events.png",
      link: "https://www.ticket.ynetsolution.com/",
    },
    {
      title: "Braden Home Health Care Services LLC",
      description: "We bring safe, loving, and caring services to those that desire to have a nursing home setting and treatment, in the comfort of their own home.",
      image: "/images/projects/braden.png",
      link: "https://bradenhomehealthcareservicesllc.com/",
    },
    {
      title: "Emerson Care Web and Mobile",
      description: "A healthcare platform where providers post job listings for medical professionals and patients easily connect with trusted care services.",
      image: "/images/projects/emerson.png",
      link: "http://5.189.185.96:8090/login",
    },
    {
      title: "Real Estate",
      description: "Discover Your Dream Home with Ease, Turning Homeownership into Reality. Your Perfect Home Awaits - Explore Real Estate Here.",
      image: "/images/projects/realestate.png",
      link: "https://www.househunt.rentalhub.co.ke/",
    },
    {
      title: "Design Studio",
      description: "Transform your ideas into something stunning, functional designs that captivate and convert at our creative hub.......................",
      image: "/images/projects/design.png",
      link: "https://design.ynetsolution.com/",
    },
    {
      title: "IKWETU",
      description: "Your Ideal Student Abode Awaits! Redefining off-campus living with comfort, community, and convenience. Welcome home to a new era in student living!",
      image: "/images/projects/ikwetu.png",
      link: "https://www.ikwetu.ynetstudyhub.com/",
    },
    {
      title: "Dreamscape International Safaris",
      description: "Experience the world together Find awesome hotel, tour, vacation and packages",
      image: "/images/projects/dreamscapeinternational.png",
      link: "https://dreamscapeinternational.com/",
    },
     {
      title: "Jawabu Tracking",
      description: "Experience the world together Find awesome hotel, tour, vacation and packages",
      image: "/images/projects/jawabutracking.png",
      link: "https://jawabutracking.co.ke/",
    },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        zIndex: "10",
        pb: { xs: "60px", sm: "60px", md: "80px", lg: "100px", xl: "120px" },
      }}
    >
      <Box
        sx={{
          maxWidth: {
            xs: "100%",
            sm: "700px",
            md: "720px",
            lg: "1140px",
            xl: "1320px",
          },
          mx: "auto",
          px: "12px",
        }}
      >
        <Box className="section-title text-center">
          <div className="sub-title">
            <span className="text-purple">Solutions</span>
          </div>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", md: "28px", lg: "34px", xl: "36px" },
            }}
          >
            Real Solutions We've Delivered
          </Typography>
        </Box>

        <Grid
          container
          justifyContent="center"
          spacing={{ xs: 2, sm: 3, md: 4 }}
        >
          {solutions.map((solution, index) => (
            <Grid key={index} item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Box className="fp-single-solution-box" sx={{ boxShadow: 3, borderRadius: 3, overflow: "hidden" }}>
                <Box component="img" src={solution.image} alt={solution.title} sx={{ width: "100%", height: 220, objectFit: "cover" }} />
                <Box p={3}>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {solution.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {solution.description}
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    component="a"
                    href={solution.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Project
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* <MobileApplications /> */}
      </Box>
    </Box>
  );
};

export default RealSolutions;
